import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

export default defineNuxtPlugin(async (app) => {
  dayjs.extend(relativeTime);
  app.provide('dayjs', dayjs);
});
